export default function checkIsNumber(string) {
  const newString = string.replace(/\D/g,"");
  return !isNaN(parseFloat(newString)) && isFinite(newString);
}
